var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 378.21 90.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e93d42;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ACE-AcroLogo-H-Red") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M353,277.55a28.41,28.41,0,0,1,23.66,12.7l.26.39,11.59-12.59,0,0-.2-.25a45.28,45.28,0,1,0,0,56.48l.2-.25L377,321.43l-.06-.07-.26.39A28.44,28.44,0,1,1,353,277.55",
    transform: "translate(-207.9 -260.72)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.19,285.13,268.28,306l0,0H245.49l19.57-44.94a5,5,0,0,0-1.79-.38H250.52a4.83,4.83,0,0,0-4.49,3l-37.91,87.06-.22.51h17.89l12.54-28.8h37.13l12.44,28.58.1.22h17.9l-37.76-86.7Z",
    transform: "translate(-207.9 -260.72)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M410.44,260.72a8.19,8.19,0,0,0-8.18,8.19v24.65h16.45V277.17H468V260.72Z",
    transform: "translate(-207.9 -260.72)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M418.71,314.23h28.74l11.72-14.85a1,1,0,0,0,.24-.64,1,1,0,0,0-1-1h-56.2V343.1a8.19,8.19,0,0,0,8.18,8.18H468V334.83H418.71Z",
    transform: "translate(-207.9 -260.72)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M495.21,297.77l-11.72,14.85a.94.94,0,0,0-.25.65,1,1,0,0,0,1,1h53.88a8.22,8.22,0,0,0,8-8V292.47L529.66,276v21.78Z",
    transform: "translate(-207.9 -260.72)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M583.69,300.86h0L544.9,262.08a4.55,4.55,0,0,0-3.25-1.34h-7.4a4.6,4.6,0,0,0-4.59,4.6v4.72l8.65,8.66a1.13,1.13,0,0,0,.1.13l27.88,27.88-24.4,24.39,2.21,18.79a1,1,0,0,0,.28.63.94.94,0,0,0,1.35,0l32.14-32.15,6-5.95a8.19,8.19,0,0,0,2.27-5.75,8.32,8.32,0,0,0-2.41-5.82",
    transform: "translate(-207.9 -260.72)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M563.14,265.47a1.21,1.21,0,0,0,1.22-1.28c0-.9-.55-1.34-1.67-1.34h-1.81v4.76h.68v-2.08h.84l0,0,1.3,2.05h.73l-1.4-2.12Zm-.79-.47h-.79v-1.61h1c.52,0,1.12.08,1.12.76S563.08,265,562.35,265Z",
    transform: "translate(-207.9 -260.72)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M562.43,260.73a4.5,4.5,0,1,0,4.5,4.5A4.46,4.46,0,0,0,562.43,260.73Zm0,8.41a3.91,3.91,0,1,1,3.84-3.91A3.83,3.83,0,0,1,562.43,269.14Z",
    transform: "translate(-207.9 -260.72)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9677731b0d8057b924aa373e31440ad3.svg";
export { ForwardRef as ReactComponent };